module.exports = "/_next/static/images/avatar_1-3174f5c7603197a471781ec0eb733a53.png";